module.exports = __webpack_public_path__ + "img/16.01d63fbe.png";